export default __webpack_public_path__ + "static/media/IndexxToken.9040482d.png";